import { getConfiguration } from '@chr/common-web-ui-configuration';
import { render } from 'react-dom';
import { App } from './App';
import { OnlineProvider } from '@chr/navisphereonline-shared-components';
import { initializeDataDog } from './common/utilities/datadog';
import { OnlineTranslationProvider } from '@chr/online-shared-ui-localizations';
import './index.scss';
import { getUserProfileAsync } from '@chr/online-shared-microsite-core';
import { AppConfig } from 'react-app-env';
import { createStore } from './createStore';
import { ChrThemeProvider } from '@chr/eds-react';


export const index = (async () => {
  // Redirct URI
  localStorage.setItem('NavisphereOnline.redirectURI', window.location.href);
  try {
    const config = await getConfiguration<AppConfig>();
    initializeDataDog(config);
    const store = createStore();
    render(
      <OnlineTranslationProvider>
        <OnlineProvider appConfig={config}>
          <ChrThemeProvider theme="Navisphere Online" hasAutoStyle={true}>
            <App config={config} store={store} />
          </ChrThemeProvider>
        </OnlineProvider>
      </OnlineTranslationProvider>,
      document.getElementById('root')
    );

    getUserProfileAsync().then(result => {
    if (result) {
      const userData = {
        displayName: result.userId?.toString(),
        companyName: result.primaryBusinessLine,
        carrierCode: result.primaryCustomerCode,
        userName: result.primaryBusinessLine,
      };
      result.userId && FS.identify(result.userId.toString(), userData);
    }});
  } catch (e) {
    // This is an error that can be thrown when ES modules aren't natively supported.
    // There is a pollyfill in place so we just swallow this error.
    // Temporary until we find a better error handling solution
    if (e instanceof Error && e.message.indexOf('Error resolving module') > -1) {
      return;
    }
    console.log(e);
    render(
      <h1>Error loading application</h1>,
      document.getElementById('root'),
    );
  }
})();
